import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookmarkIcon, TrashIcon, BriefcaseIcon, SearchIcon } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
const SavedJobs: React.FC = () => {
  const navigate = useNavigate();
  const [savedJobs, setSavedJobs] = useState([{
    id: '1',
    title: 'Senior React Developer',
    company: 'SpaceX',
    logo: 'https://logo.clearbit.com/spacex.com',
    location: 'Remote',
    salary: '$120k - $150k',
    saved: '2 days ago'
  }, {
    id: '2',
    title: 'Product Designer',
    company: 'NASA',
    logo: 'https://logo.clearbit.com/nasa.gov',
    location: 'Houston, TX',
    salary: '$90k - $120k',
    saved: '1 week ago'
  }]);
  const handleRemove = (id: string) => {
    setSavedJobs(savedJobs.filter(job => job.id !== id));
  };
  const handleJobClick = (id: string) => {
    navigate(`/jobs/${id}`);
  };
  return <div className="p-4 pb-20" data-id="element-486">
      <div className="flex items-center justify-between mb-6" data-id="element-487">
        <h1 className="text-2xl font-bold" data-id="element-488">Saved Jobs</h1>
        <div className="bg-teal-100 dark:bg-teal-900 text-teal-800 dark:text-teal-200 w-8 h-8 rounded-full flex items-center justify-center" data-id="element-489">
          <BookmarkIcon size={18} data-id="element-490" />
        </div>
      </div>
      {savedJobs.length > 0 ? <div data-id="element-491">
          {savedJobs.map(job => <Card key={job.id} className="mb-4 relative" onClick={() => handleJobClick(job.id)} hover data-id="element-492">
              <div className="flex items-start gap-3" data-id="element-493">
                <div className="h-12 w-12 rounded-lg overflow-hidden flex-shrink-0 bg-gray-100 dark:bg-gray-700 flex items-center justify-center" data-id="element-494">
                  {job.logo ? <img src={job.logo} alt={job.company} className="h-full w-full object-cover" data-id="element-495" /> : <BriefcaseIcon className="text-gray-400" data-id="element-496" />}
                </div>
                <div className="flex-1" data-id="element-497">
                  <h3 className="font-semibold text-gray-900 dark:text-gray-100" data-id="element-498">
                    {job.title}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-499">
                    {job.company}
                  </p>
                  <div className="mt-2 flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400" data-id="element-500">
                    <span data-id="element-501">{job.location}</span>
                    <span data-id="element-502">{job.salary}</span>
                  </div>
                  <div className="mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-503">
                    Saved {job.saved}
                  </div>
                </div>
                <button className="p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors" onClick={e => {
            e.stopPropagation();
            handleRemove(job.id);
          }} data-id="element-504">
                  <TrashIcon size={18} data-id="element-505" />
                </button>
              </div>
            </Card>)}
          <div className="mt-6" data-id="element-506">
            <Button variant="outline" fullWidth onClick={() => navigate('/jobs')} data-id="element-507">
              Browse More Jobs
            </Button>
          </div>
        </div> : <div className="flex flex-col items-center justify-center py-12" data-id="element-508">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-full p-6 mb-6" data-id="element-509">
            <BookmarkIcon size={48} className="text-gray-400 dark:text-gray-500" data-id="element-510" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2" data-id="element-511">
            No saved jobs yet
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-center mb-6" data-id="element-512">
            Jobs you save will appear here for easy access.
          </p>
          <Button variant="primary" onClick={() => navigate('/jobs')} icon={<SearchIcon size={18} data-id="element-514" />} data-id="element-513">
            Find Jobs
          </Button>
        </div>}
    </div>;
};
export default SavedJobs;